import { ClipboardCheck, Database, FileText, Layers, LayoutGrid, Package, PackageSearch, ShoppingBag, Truck, Users } from "lucide-react";

// Navigation grouping only — every entry points at an existing module route.
export const DEPARTMENTS = [
  {
    key: "purchasing",
    label: "Purchasing",
    icon: LayoutGrid,
    to: "/",
    paths: ["/", "/batches", "/archive"],
    modules: [
      { label: "PO Batches", desc: "Active batches and PO Archive", to: "/", icon: LayoutGrid, roles: null },
    ],
  },
  {
    key: "orders",
    label: "Orders",
    icon: ShoppingBag,
    to: "/dept/orders",
    paths: ["/dept/orders", "/orders", "/invoices", "/customers"],
    modules: [
      { label: "Customer Orders", desc: "Enter and manage customer orders", to: "/orders", icon: ShoppingBag, roles: ["owner", "admin_input", "viewer"] },
      { label: "Final Invoices", desc: "Active and archived invoices", to: "/invoices", icon: FileText, roles: ["owner", "admin_input", "admin"] },
    ],
  },
  {
    key: "operations",
    label: "Operations",
    icon: Layers,
    to: "/dept/operations",
    paths: ["/dept/operations", "/allocations", "/receiving"],
    modules: [
      { label: "FIFO", desc: "Allocate approved stock to orders", to: "/allocations", icon: Layers, roles: ["owner", "admin", "admin_input", "viewer"] },
      { label: "Receiving", desc: "Receiving queue and sessions", to: "/receiving", icon: PackageSearch, roles: ["owner", "receiving", "admin", "purchaser", "viewer"] },
      { label: "Approvals", desc: "Checker approval of receiving", to: "/receiving/approvals", icon: ClipboardCheck, roles: ["owner", "admin", "admin_input"] },
    ],
  },
  {
    key: "fulfillment",
    label: "Fulfillment",
    icon: Package,
    to: "/dept/fulfillment",
    paths: ["/dept/fulfillment", "/packing", "/shipping"],
    modules: [
      { label: "Packing", desc: "Packing jobs and photo evidence", to: "/packing", icon: Package, roles: null },
      { label: "Shipping", desc: "Shipment details and charges", to: "/shipping", icon: Truck, roles: ["owner", "admin_input", "viewer"] },
    ],
  },
  {
    key: "management",
    label: "Management",
    icon: Users,
    to: "/dept/management",
    paths: ["/dept/management", "/team", "/masters", "/owner-review"],
    modules: [
      { label: "Team Management", desc: "Staff accounts and roles", to: "/team", icon: Users, roles: ["owner"] },
      { label: "Product Master", desc: "Master product records and archive", to: "/masters", icon: Database, roles: ["owner"] },
    ],
  },
];

export const visibleModules = (dept, role) => dept.modules.filter((m) => !m.roles || m.roles.includes(role));

export const visibleDepartments = (role) => DEPARTMENTS.filter((d) => visibleModules(d, role).length > 0);

export const isDeptActive = (dept, pathname) => {
  if (dept.key === "purchasing") return pathname === "/" || pathname.startsWith("/batches") || pathname.startsWith("/archive");
  return dept.paths.some((p) => p !== "/" && (pathname === p || pathname.startsWith(`${p}/`)));
};

// Internal hierarchy for the global Back row. Detail pages keep their own in-page back button.
const MODULE_PARENT = {
  "/orders": "orders",
  "/invoices": "orders",
  "/customers": "orders",
  "/allocations": "operations",
  "/receiving": "operations",
  "/receiving/approvals": "operations",
  "/packing": "fulfillment",
  "/shipping": "fulfillment",
  "/team": "management",
  "/masters": "management",
};

export const backTarget = (pathname, role) => {
  const dept = MODULE_PARENT[pathname];
  if (!dept) return null;
  return role === "owner" ? { to: `/dept/${dept}`, label: DEPARTMENTS.find((d) => d.key === dept).label } : { to: "/", label: "PO Batches" };
};
